import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class BgRemoveTool extends BaseTool {
  public id: ToolType = 'bg-remove';
  public name = 'Magic Eraser / Background Remover';
  public cursor = 'crosshair';

  public onMouseDown(_e: MouseEvent, canvasX: number, canvasY: number): void {
    this.editor.removeColorAtPoint(canvasX, canvasY);
  }
}
